import React, { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { isEmpty } from 'lodash';
import { useFormContext } from 'framework/form';
import { ProcessAssetsFormType } from '../types';
import ProcessAssetsFormButtons from './ProcessAssetsFormButtons';
import ProcessAssetsFormFields from './ProcessAssetsFormFields';
import ProcessAssetFormPreview from '../show/ProcessAssetFormPreview';

const ProcessAssetsForm = ({ isEditForm = false, closeModal }: { isEditForm?: boolean; closeModal?: () => void }) => {
  const { data: formData, validateForm } = useFormContext();
  const [publishView, setPublishView] = useState(false);

  const { paths } = formData || {};
  const documentPath = useMemo(() => (paths?.length ? paths[0] : ''), [paths]);

  const togglePublishView = () => {
    const errors = validateForm?.();
    if (!errors || isEmpty(errors)) setPublishView(prev => !prev);
  };

  return (
    <>
      <Box>
        <Box display={publishView ? 'none' : 'block'}>
          <ProcessAssetsFormFields isEditForm={isEditForm} />
        </Box>

        {publishView && (
          <ProcessAssetFormPreview formData={formData as ProcessAssetsFormType} documentPath={documentPath} />
        )}
      </Box>

      <ProcessAssetsFormButtons
        isEditForm={isEditForm}
        publishView={publishView}
        onTogglePublishView={togglePublishView}
        onCloseModal={closeModal!}
        onCancelPreview={() => setPublishView(false)}
      />
    </>
  );
};

export default ProcessAssetsForm;
